import { axios, Response } from '../index'

const deleteTaskFile = (
  companyId: string,
  personaType: string,
  personaId: string,
  taskId: string,
  fileName: string
): Response<null> => {
  return axios.delete(`/v1/tasks/${taskId}/files/${fileName}`, {
    headers: {
      'X-CompanyID': companyId,
      'X-PersonaType': personaType,
      'X-PersonaID': personaId
    }
  })
}

export default deleteTaskFile
